$(document).ready(function () {
    const IDENTIFIER = "time_tracking_admin_tool";
    const pathShiftHtmlTable = "/action/time-tracking/shift-html-table";
    const pathSaveClocking = "/action/time-tracking/clocking";
    const pathGetClockingForm = "/action/time-tracking/clocking-form";
    const fetchShiftsHtmlTableButton = $("div#" + IDENTIFIER + "_filter_button");
    const filterStoreSelect = $("div#" + IDENTIFIER + "_filter_wrapper select.store_select");
    const modalParentElementInDOM = $('div#content');
    const clockingFormHeaderNewClocking = 'Lagre ny stempling';
    const clockingFormHeaderEditClocking = 'Endre stempling';

    let ajaxLockActive = false;

    $("div#" + IDENTIFIER + "_wrapper input.datepicker").datepicker({
        dateFormat: "dd/mm/yy"
    });

    initDateTimePickers();

    // Save clocking
    $(document).on('click', 'div#' + IDENTIFIER + '_wrapper div#' + IDENTIFIER + '_save_clocking_button', function () {
        if (ajaxLockActive){
            return false;
        }

        $.ajax({
            type: 'POST',
            url: pathSaveClocking,
            data: getClockingParameters(),
            dataType: 'json'
        }).success(function (data) {
            $('form#time_tracking_admin_tool_clocking_form').html('<div class="alert alert-success"><strong>Stempling lagret!</strong><br /><br /><br /><div id="get_new_clocking_form_button" class="btn btn-primary">Lagre ny stempling</div></div>');
            refreshShiftTable();
        }).error(function (data) {
            let modalTitle = 'Det oppstod en feil!';
            let modalMessage = $.parseJSON(data.responseText).errors;
            let modalAlertType = 'error';
            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, 'Lukk', modalAlertType);
        });
    });

    // Get new clocking form
    $(document).on('click', 'div#' + IDENTIFIER + '_wrapper div#get_new_clocking_form_button', function () {
        if (ajaxLockActive){
            return false;
        }

        // Change form header
        $('div#time_tracking_admin_tool_wrapper div#clocking_form_header h1').html(clockingFormHeaderNewClocking);

        ajaxLockActive = true;

        getClockingForm(0);
        return false;
    });

    // Click on a shift to edit it
    $(document).on('click', 'div#' + IDENTIFIER + '_wrapper table#time_tracking_admin_tool_shift_table tr td', function () {
        if (ajaxLockActive){
            return false;
        }

        // Change form header
        $('div#time_tracking_admin_tool_wrapper div#clocking_form_header h1').html(clockingFormHeaderEditClocking);

        ajaxLockActive = true;

        let parentTr = $(this).parent();
        getClockingForm(parentTr.attr("shift_id"));
        return false;
    });

    fetchShiftsHtmlTableButton.click(function (e) {
        if (ajaxLockActive){
            return false;
        }

        ajaxLockActive = true;
        refreshShiftTable();
    });

    function refreshShiftTable() {
        displayLoadingGifInButton()
        $.ajax({
            type: 'GET',
            url: pathShiftHtmlTable,
            data: getfilterParameters(),
            dataType: 'json'
        }).success(function (data) {
            removeLoadingGifFromButton();
            $("div#shift_table_wrapper").replaceWith(data.html_table);
        }).error(function (data) {
            removeLoadingGifFromButton();

            let modalTitle = 'Det oppstod en feil!';
            let modalMessage = 'Kunne ikke hente stemplinger, vennligst prøv igjen';
            let modalAlertType = 'error';

            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, 'Lukk', modalAlertType);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    function getClockingForm(shiftId) {
        let data = {};

        if (!isNaN(shiftId) && (shiftId * 1) > 0) {
            data.shift_id = shiftId;
        }
        $.ajax({
            type: 'GET',
            url: pathGetClockingForm,
            data: data,
            dataType: 'json'
        }).success(function (data) {
            $('form#time_tracking_admin_tool_clocking_form').replaceWith(data.clocking_form);
            initDateTimePickers();
        }).error(function (data) {
            let modalTitle = 'Det oppstod en feil!';
            let modalMessage = $.parseJSON(data.responseText).errors;
            let modalAlertType = 'error';
            displayInfoMessageModal(modalParentElementInDOM, modalTitle, modalMessage, 'Lukk', modalAlertType);
        }).always(function () {
            ajaxLockActive = false;
        });
    }

    /**
     * Returns parameters sent to controller
     *
     * @returns
     */
    function getfilterParameters() {
        let data = {
            from_date: getDateFromShiftTable(),
            to_date: getDateToShiftTable(),
            user_id: getUserIdShiftTable(),
        };

        if (filterStoreSelect.length) {
            data.store_sync_code = filterStoreSelect.val();
        }
        return data
    }

    /**
     * Returns parameters sent to controller
     *
     * @returns
     */
    function getClockingParameters() {
        let data = {
            shift_id: $('input#' + IDENTIFIER + '_clocking_shift_id').val(),
            time_from: $('input#' + IDENTIFIER + '_clocking_time_from').val(),
            time_to: $('input#' + IDENTIFIER + '_clocking_time_to').val(),
            user_id: $("form#time_tracking_admin_tool_clocking_form select.user_select").val(),
            comment: $("form#time_tracking_admin_tool_clocking_form textarea#time_tracking_admin_tool_clocking_comment").val(),
        };

        if (filterStoreSelect.length) {
            data.store_sync_code = $("form#time_tracking_admin_tool_clocking_form select.store_select").val();
        }
        return data
    }

    function initDateTimePickers() {
        $("div#" + IDENTIFIER + "_wrapper input.datetimepicker").datetimepicker({
            dateFormat: 'dd/mm/yy'
        });
    }

    function getDateFromShiftTable() {
        return $("input#" + IDENTIFIER + "_filter_date_from").val();
    }
    function getDateToShiftTable() {
        return $("input#" + IDENTIFIER + "_filter_date_to").val();
    }
    function getUserIdShiftTable() {
        return $("form#time_tracking_admin_tool_filter_form select.user_select").val();
    }

    function displayLoadingGifInButton() {
        fetchShiftsHtmlTableButton.html('<img src="/includes/charts/gfx/ajax-loader.gif" alt="Loading..." style="margin-right: 10px;"/> Henter data...');
    }

    function removeLoadingGifFromButton() {
        fetchShiftsHtmlTableButton.html("Oppdater");
    }

});